export const COMPANY = "company";
export const SCHOOL_OR_UNIVERSITY = "School or University";
export const SCHOOL = "school";
export const K12 = "k12";
export const EDUCATION = [SCHOOL, SCHOOL_OR_UNIVERSITY, K12];

export const SELECT_ORGANIZATION_TYPE = [
  {
    value: COMPANY,
    label: "Company",
  },
  {
    value: SCHOOL_OR_UNIVERSITY,
    label: "Adult Education (ELSA Speak app)",
  },
];

export const SELECT_ORGANIZATION_TYPE_FOR_ADMIN = [
  {
    value: COMPANY,
    label: "Company",
  },
  {
    value: SCHOOL_OR_UNIVERSITY,
    label: "Adult Education (ELSA Speak app)",
  },
  {
    value: K12,
    label: "K12 Education (ELSA Schools app)",
  },
];
